"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreconditionFailed = void 0;
const ResponseError_1 = require("./ResponseError");
class PreconditionFailed extends ResponseError_1.ResponseError {
    constructor(options) {
        super(options);
        this.name = this.constructor.name;
        this.message = this.message || PreconditionFailed.label;
        this.type = PreconditionFailed.type;
        this.statusCode = PreconditionFailed.statusCode;
        this.remediation = this.remediation ?? PreconditionFailed.remediation;
        Error.captureStackTrace(this, PreconditionFailed);
    }
}
exports.PreconditionFailed = PreconditionFailed;
PreconditionFailed.type = 'PreconditionFailed';
PreconditionFailed.label = 'Precondition Failed';
PreconditionFailed.remediation = 'Retry update request again.';
PreconditionFailed.statusCode = 412;
//# sourceMappingURL=PreconditionFailed.js.map